import { render, staticRenderFns } from "./AccessCounts.vue?vue&type=template&id=71a61c32&scoped=true&"
import script from "./AccessCounts.vue?vue&type=script&lang=ts&"
export * from "./AccessCounts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a61c32",
  null
  
)

export default component.exports